import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import QrReader from "react-qr-reader";
const ModuloGeneraPresenteAdicional = ({ pasado }) => {

    const Usuario=ObtieneDatosCookies()
    const [cadeteDni, setCadeteDni] = useState("");
    const [veoLector,setVeoLector]=useState(false)
    let scanTimeout = null;

    const handleScan = async (data) => {
        try {
            if (data) {
                // Si ya hay un timeout en curso, ignorar la lectura
                if (scanTimeout) {
//                     console.log("Lectura ignorada por repetición rápida");
                    return;
                }
    
                // Establecer un timeout para ignorar lecturas repetidas por un tiempo
                scanTimeout = setTimeout(() => {
                    scanTimeout = null;
                }, 500); // Espera 500ms para aceptar otra lectura
    
            

              handleCreaPresente(data)
            }
        } catch (error) {
            console.error("Error en handleScan:", error);
        }
    };
    
   
    
     const handleError = err => {
     console.error(err)
     }
    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Permitir solo números
        setCadeteDni(value);
    };

    const handleCreaPresente = async (dni) => {
        if (!dni) {
            alert("Por favor, ingrese un DNI válido.");
            return;
        }

        const token = btoa(`${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`);
        const client = axios.create({
            baseURL: `${process.env.REACT_APP_BASEURL}creaPresenteCadete`,
            headers: {
                Authorization: `Basic ${token}`,
            },
        });

        try {
          
            const response = await client.post("/", { cadeteDni:dni,userID:Usuario.identificacion,Operacion:"Genera Presente Manualmente"});
            if (response.data.success) {
                Swal.fire("Presente Generado Manualmente", "El cadete fue dado presente manualmente con exito, no obstante debe solicitarle al cadete que debe utilizar los lectores de asistencia.", "success");
                setCadeteDni("");
                pasado();
            }else{
                if(response.data.message=="repetido"){
                    Swal.fire("No se pudo dar el Presente Generado Manualmente", "Ya se dio presente el dia de hoy a ese cadete.", "warning");
                    setCadeteDni("");
                }else{
//                     console.log(response.data.message)
                    Swal.fire("No se pudo dar el Presente Generado Manualmente", "Probablemente el cadete este inactivo o no exista en la nomina comuniquese con DTyD", "error");
                    setCadeteDni("");
                }
             
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleCreaPresente(cadeteDni);
        }
    };

    return (
        <><div style={{display:"flex",flexWrap:"wrap",alignContent:"space-around",flexDirection:"column"}}>
  <input
                type="text"
                value={cadeteDni}
                onChange={handleChange}
                onKeyPress={handleKeyPress} // Detecta Enter
                placeholder="Ingrese DNI"
                maxLength="10"
            />
         <button onClick={() => handleCreaPresente(cadeteDni)} className="btn btn-success">Dar Presente Manual</button>

            <button onClick={()=>setVeoLector(!veoLector)} className="btn btn-danger">Activar Lector</button>
        </div>
       
          {veoLector? <QrReader   delay={500}
                         onError={handleError}
                         onScan={handleScan}
                         style={{ height: "auto", width:  "auto" }}/>:""}
        
        </>
    );
};

export default ModuloGeneraPresenteAdicional;
